export const VALID_PROCESSES = ['COFT', 'COUD', 'CORE', 'COTR', 'COUDE']